import { PhotosSetSelectedPhotoReducer } from './types';

export const photosSetSelectedPhotoReducer: PhotosSetSelectedPhotoReducer = (
  state,
  action
) => {
  const { selectedPhoto } = action.payload;

  const isPhotoAlreadySelected = state.selectedPhotos.includes(selectedPhoto);
  const updatedSelectedPhotosList = isPhotoAlreadySelected
    ? state.selectedPhotos.filter((photo) => photo !== selectedPhoto)
    : [...state.selectedPhotos, selectedPhoto];

  return {
    ...state,
    selectedPhotos: updatedSelectedPhotosList,
  };
};
